import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as actions from '../combosAction';
import ComboList from './components/CombosList';
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb';
import { LoadingBlueLarge, Icon, Button } from 'merchant-portal-components';
import CombosSortModal from './ComboSort/CombosSortModal';
import { TextField, InputAdornment } from '@material-ui/core';
import ReactGA from 'react-ga';
import { NoItemsFound } from '../../NoItemsFound';
import { InfoIcon } from '../../InfoIcon';
const Wrapper = styled.div`
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  border-radius: 12px;
  padding: 37px 0;
`;
const StyledTab = styled.div`
  margin: 10px;
  margin-left: 40px;
  display: flex;
`;

const StyledSpanCD = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  background-color: #2440ae;
  color: white;
  padding-left: ${(props) => (props.isSD == true ? '5px' : '3.2px')};
  padding-right: ${(props) => (props.isSD == true ? '5px' : '3.2px')};
  padding-top: ${(props) => (props.isSD == true ? '2px' : '3.2px')};
  padding-bottom: ${(props) => (props.isSD == true ? '2px' : '3.2px')};
  font-size: 13.5px;
`;

const StyledNumberSpan = styled.span`
  display: block;
  margin-top: 20%;
`;
const BtnTxtContainer = styled.div`
  display: inline-flex;
`;
const TxtContr = styled.div`
  margin-top: 6px;
  font-size: 18px;
  margin-right: 6px;
  color: #6f6f76;
`;

const StyledTabBtn = styled.button`
  width: 160px;
  cursor: pointer;
  background-color: ${(props) =>
    props.isActive == false ? 'lightblue' : '#2440ae'};
  color: ${(props) => (props.isActive == false ? '#000' : '#fff')};
  background-color: ${(props) =>
    props.isActive == false ? '#fff' : '#E6EBFF'};
  color: ${(props) => (props.isActive == false ? '#DCDCDC' : '#2440ae')};
  font-weight: ${(props) => (props.isActive == false ? '' : '')};
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
`;

const MessageWrapper = styled.div`
  display: flex;
  height: 300px;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;
const TextSearch = styled.div``;
const TopDiv = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-gap: 20px;
  margin: 0 37px 37px 37px;
`;
let CombosListContainer = ({
  archivedCombos,
  getArchivedCombos,
  combosList,
  initiateEditCombo,
  toggleCombo,
  requestParams,
  businesses,
  isRequestingGetCombos,
  initiateCreateCombo,
  isSavingComboPositions,
  handleSortingComboSubmit,
  searchString,
  setSearchString,
  getCombos,
  allCombosPositions,
  comboReorderRequestParams,
  updateComboRequestParams,
  updateCombosPosition,
}) => {
  const [selectedFilter, setSelectedFilter] = useState('active');
  const [isSortModalOpen, setIsSortModalOpen] = useState(false);

  useEffect(() => {
    getArchivedCombos(requestParams);
  }, []);

  const comboDisplayList = useMemo(() => {
    if (!combosList || !archivedCombos) return [];
    switch (selectedFilter) {
      case 'active':
        return combosList?.filter((each) => each.is_active == true);
      case 'inactive':
        return combosList?.filter((each) => each.is_active == false);
      case 'archived':
        return archivedCombos;
      default:
        return combosList;
    }
  }, [combosList, archivedCombos, selectedFilter]);

  useEffect(() => {
    if (selectedFilter == 'archived') {
      getArchivedCombos(requestParams);
    }
  }, [selectedFilter]);

  const handleSearch = (e) => {
    const searchString = e.target.value.toLowerCase();
    setSearchString(searchString);
  };
  const handleClearSearch = () => {
    setSearchString('');
  };
  useEffect(() => {
    ReactGA.pageview(window.location.pathname, undefined, 'Combo List');
  }, []);

  return (
    <Fragment>
      <BreadCrumb pageName='Combos and Specials' />
      <Wrapper>
        <TopDiv>
          <TextSearch>
            <TextField
              type='text'
              style={{ width: '100%' }}
              variant='outlined'
              value={searchString}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <Icon className='fal fa-search' />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='start'>
                    <Icon
                      className='fas fa-times-circle'
                      style={{ color: '#193053' }}
                      onClick={handleClearSearch}
                    />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
              placeholder='Search combos'
            />
          </TextSearch>
          <Button
            onClick={() => initiateCreateCombo()}
            style={{ width: '100%' }}
          >
            Create a Combo
          </Button>
        </TopDiv>
        {true && (
          <StyledTab>
            <div>
              <StyledTabBtn
                isActive={selectedFilter == 'active'}
                onClick={() => {
                  setSelectedFilter('active');
                }}
              >
                <BtnTxtContainer>
                  <TxtContr>Active</TxtContr> &nbsp;{' '}
                  <StyledSpanCD
                    isSD={
                      combosList.filter((ech) => ech.is_active == true).length <
                      10
                    }
                  >
                    <StyledNumberSpan>
                      {combosList.filter((ech) => ech.is_active == true).length}
                    </StyledNumberSpan>
                  </StyledSpanCD>
                </BtnTxtContainer>
              </StyledTabBtn>
            </div>
            <div>
              <StyledTabBtn
                isActive={selectedFilter == 'inactive'}
                onClick={() => {
                  setSelectedFilter('inactive');
                }}
              >
                <BtnTxtContainer>
                  <TxtContr>Inactive</TxtContr> &nbsp;{' '}
                  <StyledSpanCD
                    isSD={
                      !(
                        combosList.filter((ech) => ech.is_active == false)
                          .length >= 10
                      )
                    }
                  >
                    <StyledNumberSpan>
                      {
                        combosList.filter((ech) => ech.is_active == false)
                          .length
                      }
                    </StyledNumberSpan>
                  </StyledSpanCD>
                </BtnTxtContainer>
              </StyledTabBtn>
            </div>
            <div>
              <StyledTabBtn
                isActive={selectedFilter === 'archived'}
                onClick={() => {
                  setSelectedFilter('archived');
                }}
              >
                <BtnTxtContainer>
                  <TxtContr>Archived</TxtContr> &nbsp;{' '}
                  <StyledSpanCD isSD={archivedCombos.length < 10}>
                    <StyledNumberSpan>{archivedCombos.length}</StyledNumberSpan>
                  </StyledSpanCD>
                </BtnTxtContainer>
              </StyledTabBtn>
            </div>
            <InfoIcon includeArchive />
          </StyledTab>
        )}

        <ComboList
          selectedFilter={selectedFilter}
          initiateEditCombo={initiateEditCombo}
          combos={comboDisplayList}
          toggleCombo={toggleCombo}
          requestParams={requestParams}
          businesses={businesses}
          setIsSortModalOpen={setIsSortModalOpen}
          searchString={searchString}
          handleClearSearch={handleClearSearch}
          getCombos={getCombos}
          isRequestingGetCombos={isRequestingGetCombos}
        />
        {isSortModalOpen && (
          <CombosSortModal
            combosList={combosList}
            setIsSortModalOpen={setIsSortModalOpen}
            isSavingComboPositions={isSavingComboPositions}
            handleSortingComboSubmit={handleSortingComboSubmit}
            allCombosPositions={allCombosPositions}
            comboReorderRequestParams={comboReorderRequestParams}
            updateComboRequestParams={updateComboRequestParams}
            updateCombosPosition={updateCombosPosition}
          />
        )}
      </Wrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isRequestingGetCombos: state.combosReducer.isRequestingGetCombos,
  combosList: state.combosReducer.combosList,
  meta: state.combosReducer.meta,
  requestParams: state.combosReducer.requestParams,
  isSavingComboPositions: state.combosReducer.isSavingComboPositions,
  allInitialCombos: state.combosReducer.allInitialCombos,
  comboReorderRequestParams: state.combosReducer.comboReorderRequestParams,
  archivedCombos: state.combosReducer.archivedCombos,
});

export default connect(mapStateToProps, actions)(CombosListContainer);
